module.exports = __webpack_public_path__ + "img/youtube.5f993b4.svg";